import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.848 2.028a4.8 4.8 0 0 1-2.488-.677C8.627.919 7.893.491 7.165.051c-.121-.072-.204-.066-.322.004-.78.466-1.563.932-2.353 1.383-.707.405-1.48.586-2.296.59q-.986.002-1.972 0H.01v.205c0 2.042-.029 4.084.006 6.124.05 2.932 1.439 5.054 4.112 6.348.894.432 1.807.83 2.707 1.25a.35.35 0 0 0 .334.005c.954-.445 1.923-.862 2.866-1.329 2.271-1.124 3.566-2.947 3.92-5.421L14 8.915V2.031z"
    }, null, -1)
  ])))
}
export default { render: render }